import { Schema } from '@togglecorp/ravl';

const timesheetSchema: Schema[] = [
    {
        doc: {
            name: 'weeklyHoliday',
            description: 'Weekly holiday schema',
        },
        fields: {
            id: { type: 'uint', required: true },
            day: { type: 'uint', required: true },
        },
    },
    {
        doc: {
            name: 'dateSpecificHoliday',
            description: 'Date specific holiday schema',
        },
        fields: {
            id: { type: 'uint', required: true },
            date: { type: 'string', required: true },
            reason: { type: 'string' },
            genders: { type: 'array.string' },
        },
    },
    {
        doc: {
            name: 'holidays',
            description: 'holiday schema',
        },
        fields: {
            weeklyHolidays: { type: 'array.weeklyHoliday', required: true },
            dateSpecificHolidays: { type: 'array.dateSpecificHoliday', required: true },
        },
    },
];

export default timesheetSchema;
